<template>
    <template v-if="!$store.state.waitingRequest">
        <main>
            <h1>Tes jeux favoris <i class="fas fa-heart"></i></h1>
            
            <p class="gamesNumber">{{ lesJeux.length }} {{ lesJeux.length == 1 ? 'jeu ajouté' : 'jeux ajoutés' }} ! <i></i></p>
            
            <section v-if="lesJeux.length > 0">
                <div class="all-games">
                    <div class="jeu-container" v-for="unJeu in lesJeux" :key="unJeu.id">
                        <div class="jeu">
                            <div class="ribbon-new-container" v-if="(((nowDate - (new Date(unJeu.created_at.replace(/-/g, '/')).getTime()/1000))/3600).toFixed(2)) <= 72.00">
                                <div class="ribbon-new">NOUVEAU</div>
                            </div>
                            
                            <router-link :to="'/' + unJeu.title_url" :title="unJeu.title">
                                <div class="img"><div class="background" :style="{'background-image' : 'url(\'/games/static/miniatures/' + unJeu.image_url + '\')'}"></div></div>
                                <div class="contenu">
                                    <p>{{ unJeu.title }}</p>
                                    <span>le {{ dateFr(unJeu.playDate) }}</span>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>

            <section v-if="lesJeux.length == 0" class="noGames">
                <div class="left">
                    <i class="fas fa-question"></i>
                </div>

                <div class="right">
                    <h2>Tu n'as ajouté aucun jeu en favoris !</h2>

                    <p>Parcours notre catalogue de jeux en ligne pour trouver ton futur jeu préféré.</p>
                    <p>Tu pourras retrouver tous tes jeux ajoutés en "favoris" sur cette page.</p>
                    <p><router-link :to="'/' + randomTitle">Clique ici</router-link> pour accéder à un jeu aléatoire !</p>
                </div>
            </section>
            
            <hr v-if="lesJeux.length == 0"/>

            <section v-if="lesJeux.length == 0">
                <div class="all-games">
                    <div class="jeu-container" v-for="game in randomGames" :key="game.id">
                        <div class="jeu">
                            <div class="ribbon-new-container" v-if="(((nowDate - (new Date(game.created_at.replace(/-/g, '/')).getTime()/1000))/3600).toFixed(2)) <= 72.00">
                                <div class="ribbon-new">NOUVEAU</div>
                            </div>
                            
                            <router-link :to="'/' + game.title_url" :title="game.title">
                                <div class="img"><div class="background" :style="{'background-image' : 'url(\'/games/static/miniatures/' + game.image_url + '\')'}"></div></div>
                                <div class="contenu">
                                    <p>{{ game.title }}</p>
                                    <span>Joué {{ game.view_count }} fois</span>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>

            <div class="ad-banner">
                <ins class="adsbygoogle"
                data-ad-client="ca-pub-2512331316053279"
                data-ad-slot="6346220535"></ins>
            </div>
        </main>
    </template>
    <template v-else>
        <SkeletonCategorie />
    </template>
</template>

<script>
import SkeletonCategorie from '../components/SkeletonCategorie.vue';
import LocalDb from '../mixins/localdb';
import AddGoogleScripts from '../mixins/addGoogleScripts';

export default {
    name: 'Favoris',
    mixins: [LocalDb, AddGoogleScripts],
    components: {
        SkeletonCategorie
    },
    data() {
        return {
            nowDate: null,

            lesJeux: [],
            randomTitle: '',
            randomGames: [],
            
            metas : {
                title: 'Tes jeux favoris - Games™ par ClickTestCPS',
                meta: [
                    {
                        name: 'robots',
                        content: 'none'
                    },
                    {
                        property: 'og:image',
                        content: 'https://clicktestcps.fr/og-games.png'
                    },
                    {
                        property: 'og:title',
                        content: 'Jeux en ligne gratuits en un clic - Jeu FR '+new Date().getFullYear()+' sans inscription - Games™ par ClickTestCPS'
                    },
                    {
                        property: 'og:description',
                        content: 'Jouez à des centaines de jeux en ligne gratuitement et sans inscription. Une sélection unique de jeux en ligne gratuits alimentée quotidiennement'
                    }
                ]
            }
        }
    },
    mounted() {
        useHead(this.metas);
        this.$store.commit('setRequestTrue');
        this.getFavoriteGames();
        
        this.nowDate = new Date().getTime()/1000;
    },
    methods: {
        getFavoriteGames() {
            let favoriteGamesId = [];

            this.db_playedGames.iterate(function(value, key) {
                if(value.favorite) {
                    favoriteGamesId.push(key);
                }
            }).then(() => {
                if(favoriteGamesId.length > 0) {
                    
                    let formData = new FormData();
                    formData.append('data', JSON.stringify({
                        post: "1",
                        favoriteGames: favoriteGamesId
                    }));

                    let storage = [];

                    axios
                    .post(this.$store.state.apiUrl+"?request=getFavoriteGames", formData)
                    .then((response) => {
                        if(response.data.length > 0) {
                            this.db_playedGames.iterate(function(value, key) {
                                storage.push({id:key, playDate: value.played_at});
                            }).then(() => {
                                this.lesJeux = this.mergeArrays(storage, response.data);
                                this.lesJeux.sort((b, a) => new Date(a.playDate) - new Date(b.playDate));
                            });
                        }
                    })
                    .finally(() => {
                        this.$store.commit('setRequestFalse');
                    });
                }
                else {
                    this.$store.commit('setRequestFalse');

                    this.getRandomGames();
                    this.getRandomGame();
                }
            });
        },
        mergeArrays(storage, db) {
            let array = [];

            for(let i = 0; i < storage.length; i++) {
                if(db.find((itmInner) => itmInner.id === storage[i].id)) {
                    array.push({
                        ...storage[i], 
                        ...(db.find((itmInner) => itmInner.id === storage[i].id))}
                    );
                }
            }
            
            return array;
        },
        dateFr(date) {
            function handleZeros(nbr) {
                let string = (nbr < 10) ? ('0' + nbr.toString()) : (nbr.toString());
                return string;
            }
            
            let dd = date.getDate();
            dd = (dd == 1 ? dd.toString() + 'er' : dd);

            let monthsFr = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
            let mm = monthsFr[date.getMonth()];

            let yyyy = handleZeros(date.getFullYear());

            let hh = date.getHours();
            let ii = handleZeros(date.getMinutes());

            return dd + ' ' + mm + ' ' + yyyy + ' à ' + hh + 'h' + ii;
        },
        getRandomGames() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getRandomGames", formData)
            .then((response) => {
                if(response.data.length > 0) {
                    this.randomGames = response.data;
                }
            });
        },
        getRandomGame() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getRandomGame", formData)
            .then((response) => {
                this.randomTitle = response.data.title_url;
            });
        }
    }
}
</script>

<style scoped src="@/assets/categorie.css">
</style>
<style scoped src="@/assets/favoris.css">
</style>